export default "__VITE_ASSET__DxmmJ_QR__"